import React from 'react';
import styles from './About.module.css';
const AboutPage = () => {


    return (
        <>
        <h1>About</h1>
        </>
    )
}

export default AboutPage;



